import { AppConfigService } from './app-config.service';

// tslint:disable-next-line:typedef
export function AppConfigLoader(configService: AppConfigService) {
    // note: this factory need to return a function (that return a promise)
    return () => configService.loadConfig('./assets/json/app-settings.json');
}


export function AppConfigConstants(constantService: AppConfigService) {
    // note: this factory need to return a function (that return a promise)
    return () => constantService.loadConstants('./assets/json/app-constants.json');
}
